import { Component, Vue} from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class PickerMixin extends Vue {
  format = 'YYYY-MM-DD HH:mm:ss'

  get storeQueryTemporary() {
    switch(this.$route.name) {
      case 'app.index':
        return {
          action: 'dashboardQueryTemporary',
          path: this.$store.state.dashboard.queryTemporary
        };

      default:
        return {
          action: 'tablePeriodTemporaryForCurrentTab',
          path: this.$store.getters.tableQueryForCurrentTab
        }
    }
  }

  get baseItems() {
    return [
      {value: 'today',          text: this.t('Today')},
      {value: 'yesterday',      text: this.t('Yesterday')},
      {value: 'last24hours',    text: this.t('Last 24 Hours')},
      {value: 'last48hours',    text: this.t('Last 48 Hours')},
      {value: 'last3days',      text: this.t('Last 3 days')},
      {value: 'last7days',      text: this.t('Last 7 days')},
      {value: 'last30days',     text: this.t('Last 30 days')},
      {value: 'thisMonth',      text: this.t('This Month')},
      {value: 'lastMonth',      text: this.t('Last Month')},
      {
        value: 'maxAvailable',
        text: this.t('Max. available'),
        help: this.t('Access the report data for the maximum available period for your plan or purchased add-on.')
      },
      {value: 'customDateTime', text: this.t('Date Range')},
    ]
  }

  getRangeValueColection({timezone}:{timezone:string}) {
    timezone = timezone || this.storeQueryTemporary.path?.timezone;
    return {
      'today': {
        from:moment()
          .startOf('day')
          .format(this.format),
        to: moment()
          .endOf('day')
          .format(this.format)
      },
      'yesterday': {
        from:moment()
          .startOf('day')
          .subtract(1, 'days')
          .format(this.format),
        to:moment()
          .endOf('day')
          .subtract(1, 'days')
          .format(this.format)
      },
      'last3days': {
        from:moment()
          .startOf('day')
          .subtract(2, 'days')
          .format(this.format),
        to:moment()
          .endOf('day')
          .format(this.format)
      },
      'last7days': {
        from:moment()
          .startOf('day')
          .subtract(6, 'days')
          .format(this.format),
        to:moment()
          .endOf('day')
          .format(this.format)
      },
      'last30days': {
        from:moment()
          .subtract(29, 'days')
          .startOf('day')
          .format(this.format),
        to:moment()
          .endOf('day')
          .format(this.format)
      },
      'last24hours': {
        from:moment()
          .tz(timezone)
          .startOf('hour')
          .subtract(23, 'hours')
          .format(this.format),
        to:moment()
          .tz(timezone)
          .startOf('hour')
          .add(1,'hour')
          .format(this.format)
      },
      'last48hours': {
        from:moment()
          .tz(timezone)
          .startOf('hour')
          .subtract(47, 'hours')
          .format(this.format),
        to:moment()
          .tz(timezone)
          .startOf('hour')
          .add(1,'hour')
          .format(this.format)
      },
      'thisMonth': {
        from:moment()
          .startOf('month')
          .format(this.format),
        to:moment()
          .endOf('day')
          .format(this.format)
      },
      'lastMonth': {
        from:moment()
          .subtract(1, 'months')
          .startOf('month')
          .format(this.format),
        to:moment()
          .subtract(1, 'months')
          .endOf('month')
          .format(this.format)
      },
      'maxAvailable': {
        from: moment()
          .subtract(this.$store.state.billing.limits.dataRetention, 'months')
          .startOf('day')
          .format(this.format),
        to:moment()
          .endOf('day')
          .format(this.format)
      }
    }
  }

}